import {networkError} from "./ui";
import {deleteProjectInvite$, getProjectInvites$} from "../services/projects";
import * as R from "ramda";
import moment from "moment";

export const ADD_PROJECT_CONTACTS = 'ADD_PROJECT_CONTACTS';
export const addProjectContacts = (contacts) => ({type: ADD_PROJECT_CONTACTS, payload: contacts});
export const API_GET_PROJECT_CONTACTS = 'API_GET_PROJECT_CONTACTS';
// export const getProjectContacts = (projectId, offset) => ({
//   type: API_GET_PROJECT_CONTACTS,
//   payload: {projectId, offset}
// });
export const API_GET_PROJECT_CONTACTS_DONE = 'API_GET_PROJECT_CONTACTS_DONE';
export const getProjectContactsDone = (response) => ({type: API_GET_PROJECT_CONTACTS_DONE, payload: response});

export const getProjectContacts = (projectId) => async (dispatch, getState) => {
  const cache = ({fetched = moment(), loading = true, error = null} = {}) => ({
    fetched,
    loading,
    error,
  });
  try {
    let soFar = 0;
    let theSize = 0;
    let nextOffset;
    let old_cache = R.path(['projectcontacts', 'data', projectId, 'cache'], getState()) || {};
    dispatch(addProjectContacts([{...old_cache, projectid: projectId, contactuserid: 'cache', ...cache()}]));
    do {
      let { response, status } = await getProjectInvites$({
        projectId,
        offset: nextOffset,
      }).toPromise();
      if (status === 204 || response === null) return;
      const { results, offset, size } = response;
      theSize = size;
      soFar += results.length;
      if (results.length > 0) {
        dispatch(addProjectContacts(results));
        nextOffset = R.last(results).contactuserid;
      }
      old_cache = R.path(['projectcontacts', 'data', projectId, 'cache'], getState()) || {};
      dispatch(addProjectContacts([{...old_cache, size, ...cache()}]));
    } while (soFar < theSize);
    old_cache = R.path(['projectcontacts', 'data', projectId, 'cache'], getState()) || {};
    dispatch(addProjectContacts([{...old_cache, size: theSize, ...cache({loading: false})}]));
  } catch (error) {
    dispatch(networkError({ ...error, number: '10124-' + error.status }))
  }
};


export const DELETE_PROJECT_CONTACT = 'DELETE_PROJECT_CONTACT';
export const deleteProjectContact = (projectId, userId) => ({ type: DELETE_PROJECT_CONTACT, payload: { projectId, userId }});

export const removeProjectContact = (projectId, userId) => async (dispatch, getState) => {
  try {
    await deleteProjectInvite$({ projectId, userId }).toPromise();
    dispatch(deleteProjectContact(projectId, userId));
  } catch (error) {
    dispatch(networkError({...error, number: '10004-'+error.status}));
  }
};



// WEBPACK FOOTER //
// ./src/actions/projectcontacts.js